import React, {useRef, useState} from "react";
import {Link, useHistory, useLocation} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import Breadcrumb from 'layouts/admin/Breadcrumb';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import { Tooltip } from 'react-tooltip';
import UIDatePicker from "components/datepicker";
import useToggleState from 'components/hooks/useToggleState';
import ModalPopup from 'components/modal/';
import DateUtil from "utils/DateUtil";
import CommonUtil from "utils/CommonUtil";
import StringUtil from "utils/StringUtil";
import UITextArea from "components/atoms/textarea/UITextArea";
import UISelect from "components/selectbox/UISelect";
import UIUtils from "utils/UIUtils";
import codeDataStore from "common/codedata/store/CodeDataStore";
import {CodeData} from "../../../../common/codedata/source/CodeDataSource";
import TbComFile from "../../../../domain/main/com/file/TbComFile";
import PageLoading from "../../../../components/loading";
import paramStore from "../../../../common/page/store/ParamStore";
import UI from "../../../../components/UI";
import TbComFileMapngDetail from "../../../../domain/main/com/file/mapng/TbComFileMapngDetail";
function ContentsContainer() {
	const [corpList, setCorpList] = React.useState<any[]>([]);
	const [corpListText, setCorpListText] = React.useState('');
	const [TSK_REQ_NO,setTSK_REQ_NO] = useState(''); //과제번호
	const [TSK_REQ_MODI_SEQ,setTSK_REQ_MODI_SEQ] = useState(''); //과제번호
	const [tskCloDate,setTskCloDate] = useState(''); //과제기간 종료
	const [tskPeriod,setTskPeriod] = useState(''); //과제기간 월일 표기
	const [suppContDivNm,setSuppContDivNm] = useState(''); //기금사용용도
	const [tskReqStsNm,setTskReqStsNm] = useState(''); //과제명
	const [tskReqStsCd,setTskReqStsCd] = useState(''); //과제명
	const [subYn,setSubYn] = useState('N'); //제출여부
	const [cloYn,setCloYn] = useState('N'); //종료여부
	const [tskReqDate,setTskReqDate] = useState(''); //과제수정번호
	const [oldTskInfo,setOldTskInfo] = useState<any>([]);
	const [selectCorpList,setSelectCorpList] = useState(); //선택한 수행기관 text
	const [loadFinish,setLoadFinish] = useState(false);

	//파일정보 선언
	const [reqFileNm, setReqFileNm] = useState('');
	const [planFileNm, setPlanFileNm] = useState('');
	const [bizFileNm, setBizFileNm] = useState('');

	const [rightCorpList,setRightCorpList] = useState([]); //선택한 수행기관 시트 데이터

	const [corpLogoFileValue] = useState(new TbComFile());
	const [bizLicFileValue] = useState(new TbComFile());
	const [fileValue] = useState(new TbComFile());

	// REQ - 신청서, PLAN - 계획서, 수행기관 사업자 등록증 - BIZ
	const [reqFileValue] = useState(new TbComFile());
	const [planFileValue] = useState(new TbComFile());
	const [bizFileValue] = useState(new TbComFile());
	const [otherFiles] = useState(new TbComFile());

	const [uploadComp, setUploadComp] = useState(false);
	const [fileInfoList, setFileInfoList] = React.useState<any[]>([]);
	const [uploadComp2103, setUploadComp2103] = useState(false);
	const [uploadComp2104, setUploadComp2104] = useState(false);
	const [fileInfoList2103, setFileInfoList2103] = React.useState<any[]>([]);
	const [fileInfoList2104, setFileInfoList2104] = React.useState<any[]>([]);
	const [fileInfoListPop, setFileInfoListPop] = React.useState<any[]>([]);

	//파일업로드
	const [uploadId, setUploadId] = React.useState("");
	const [uploadId2103, setUploadId2103] = React.useState("");
	const [uploadId2104, setUploadId2104] = React.useState("");


	function dateToStr(dateText) {

		if(dateText == null) return '';

		if(/^(-?)[0-9]+$/.test(dateText)){
			dateText = Number(dateText);
		}
		let date = new Date(dateText);
		let week = new Array('일', '월', '화', '수', '목', '금', '토');


		let year = date.getFullYear();
		let month = date.getMonth()+1;
		let day = date.getDate();
		let dayName = week[date.getDay()];

		return year+'-'+dateLpad(month)+'-'+dateLpad(day)+'('+dayName+')';
	}

	function dateLpad(num){
		if(num.toString().length == 1){
			num = "0"+num;
		}

		return num;
	}

	const serverUrl = 'http://dev.fund.win-win.or.kr/';
	const location = useLocation();
	const history = useHistory();
	const receivedData = (location.state as any)?.data;


	const [bizCd,setBizCd] = useState('');
	const [amtList, setAmtList] = React.useState<any[]>([{ SUPP_ITEM : '', CALC_BASIS : '', PROF_MATH : '', SUPP_AMT : '', num : 0 , checked : false}]);
	const [totalAmt, setTotalAmt] = useState(0); //금액 총액

	const [addAmtList, setAddAmtList] = React.useState<any[]>([{ ADD_SUPP_ITEM : '', ADD_CALC_BASIS : '', ADD_PROF_MATH : '', ADD_SUPP_AMT : '', num : 0 , checked : false}]);
	const [addTotalAmt, setAddTotalAmt] = useState(0); 

	const [tskStDate,setTskStDate] = useState(new Date()); //과제기간 시작
	const [tskEnDate,setTskEnDate] = useState(new Date(new Date().getFullYear()+'-12-31')); //과제기간 종료
	const [funPurUseNm,setFunPurUseNm] = useState(''); //기금사용용도
	const [funPurUseNo,setFunPurUseNo] = useState('1');
	const [bizKindNm1,setBizKindNm1] = useState(''); //과제분류 대
	const [bizKindNm2,setBizKindNm2] = useState(''); //과제분류 소
	const [bizKindCd1,setBizKindCd1] = useState(''); //과제분류 대 코드
	const [bizKindCd2,setBizKindCd2] = useState(''); //과제분류 소 코드
	const [fpucList,setFpucList] = useState<any[]>([]); //과제분류 대 코드
	const [bizKindCd1List,setBizKindCd1List] = useState<any[]>([]); //과제분류 대 코드
	const [bizKindCd2List,setBizKindCd2List] = useState<any[]>([]); //과제분류 소 코드
	const [funPurUseCd,setFunPurUseCd] = useState(''); //기부금 사용용도

	const [bizNm,setBizNm] = useState(''); //사업명
	const [tskNm,setTskNm] = useState(''); //과제명
	const [suppCorpCnt,setSuppCorpCnt] = useState(0); //중소기업 지원수
	const [otherSuppCorpCnt,setOtherSuppCorpCnt] = useState(0); //중소기업 외 지원수
	const [elec, setElec] = useState('');
	const [elecApprYn, setElecApprYn] = useState('');

	//밑에 담당자 정보
	const [corpNm,setCorpNm] = useState(''); //과제명
	const [bizNo,setBizNo] = useState(''); //사업자번호
	const [corpRegNo,setCorpRegNo] = useState(''); //사업자번호
	const [personNm,setPersonNm] = useState(''); //이름
	const [posiNm,setPosiNm] = useState(''); //직급
	const [deptNm,setDeptNm] = useState(''); //부서명
	const [emailAdres,setEmailAdres] = useState(''); //이메일
	const [ofcTelNo,setOfcTelNo] = useState(''); //전화번호

	const [foreTskYn, setForeTskYn] = useState('');
	const [suppCont,setSuppCont] = useState(''); //지원내용, 과제개요 // as-is, to-be
	const [exeEffDesc,setExeEffDesc] = useState(''); //기대효과, 정성내용 // as-is, to-be
	const [qList,setQList] = useState({ //기대효과 14문항
		q1: '', q2: '', q3: '', q4: '', q5: '', q6: '', q7: '',
		q8: '', q9: '', q10: '', q11: '', q12: '', q13: '', q14: ''
	});

	const [queList,setQueList] = useState<any>([]);

	async function saveTsk(){
		let typeNm = "";
		if(state.funPurUseCd == ''){
			typeNm = "[기금사용용도]";
		}else if(state.bizKindCd1 == ''){
			typeNm = "[과제분류(대분류)]";
		}else if(state.bizKindCd2 == ''){
			typeNm = "[과제분류(소분류)]";
		}
		
		if(typeNm !=""){
			UIUtils.alert(<><div className='ta-center'>필수 입력이 완료되지 않았습니다. <br/>다시 확인해 주세요.<br/>{typeNm}</div></>).then();
			return
		}
		
		if(await UIUtils.confirm('저장하시겠습니까?')){
			let param = {};

			param = {
				TSK_REQ_NO : receivedData.TSK_REQ_NO,
				TSK_REQ_MODI_SEQ : receivedData.TSK_REQ_MODI_SEQ,
				"FUN_PUR_USE_CD": state.funPurUseCd,
				"FUN_PUR_USE_NO": state.funPurUseNo,
				"BIZ_KIND_CD_1": state.bizKindCd1,
				"BIZ_KIND_CD_2": state.bizKindCd2,
			};

			//파라미터 전송
			const response:any = await CommonUtil.execute({
				url:'adm_1308_update',
				data: param
			}).then((response: any) => {
				UIUtils.alert('저장되었습니다.').then(()=>{
					const result = response;

					// 다른 페이지로 이동하면서 데이터 전달
					history.push({
						pathname: './adm1305',
						state: { data: JSON.parse(receivedData.vAll_PARAM) }
					});
				});
        	}).catch((error) => {
            	CommonUtil.showAxiosError(error);
            	return;
        	});
			console.log(response);
		}


	}

	const defaultState = {
		funPurUseNm: '', //기금사용용도
		funPurUseNo: '1',
		bizKindNm1: '', //과제분류 대
		bizKindNm2: '', //과제분류 소
		bizKindCd1: '', //과제분류 대 코드
		bizKindCd2: '', //과제분류 소 코드
		fpucList: [], //과제분류 대 코드
		bizKindCd1List: [] as CodeData[], //과제분류 대 코드
		bizKindCd2List: [] as CodeData[], //과제분류 소 코드
		funPurUseCd: '', //기부금 사용용도
	}

	const [state, setState] = useState((() => {
		const result = receivedData;
		console.log(result)
		let info = result.REC1[0];
	return {
			...defaultState,
			bizKindNm1: info.BIZ_KIND_NM_1,
			bizKindCd1List: codeDataStore.get("common.suppSizeA," + info.FUN_PUR_USE_NO),
			bizKindNm2: info.BIZ_KIND_NM_2,
			bizKindCd2List: codeDataStore.get("common.suppSizeB," + info.FUN_PUR_USE_NO + "," + info.BIZ_KIND_CD_1),
			funPurUseCd: info.FUN_PUR_USE_CD,
			funPurUseNo: info.FUN_PUR_USE_NO,
			bizKindCd1: info.BIZ_KIND_CD_1,
			bizKindCd2: info.BIZ_KIND_CD_2
		}
	})());

	async function initCall(){

		let param1 = {TSK_REQ_NO : receivedData.TSK_REQ_NO};

		const response1:any = await CommonUtil.execute({
			url:'tsk_que_list',
			data: param1
		})

		const result1 = response1;
		setQueList(result1.REC);
		console.log(result1)


		let param = {
			TSK_REQ_NO : receivedData.TSK_REQ_NO,
			TSK_REQ_MODI_SEQ : receivedData.TSK_REQ_MODI_SEQ
		};



		const response:any = await CommonUtil.execute({
			url:'usr_2108',
			data: param
		})

		const result = response;
		console.log(result)
		let info = result.REC1[0];
		//setOldTskInfo(info)
		setTSK_REQ_NO(info.TSK_REQ_NO);
		setTSK_REQ_MODI_SEQ(info.TSK_REQ_MODI_SEQ)

		setTskStDate(new Date(Number(info.TSK_ST_DATE)));
		setTskEnDate(new Date(Number(info.TSK_EN_DATE)));
		setTskCloDate(dateToStr(info.TSK_CLO_DATE));
		setTskPeriod(info.TSK_PERIOD);


		setSuppContDivNm(info.SUPP_CONT_DIV_NM);
		setBizNm(info.BIZ_NM);
		setTskNm(info.TSK_NM);
		setSuppCorpCnt(info.SUPP_CORP_CNT);
		setOtherSuppCorpCnt(info.OTHER_SUPP_CORP_CNT);
		setTskReqDate(dateToStr(info.TSK_REQ_DATE));
		setSubYn(info.SUB_YN);
		setCloYn(info.TSK_CLO_YN);
		setTskReqStsNm(info.TSK_REQ_STS_NM);
		//setTskReqStsCd(info.TSK_REQ_STS_CD);

		let elecNm = "";
		if(info.ELEC_APPR_YN == 'Y'){
			elecNm = "전자인증";
		}else if(info.FILE_ID != null){
			elecNm = "서면"
		}else{
			elecNm="미제출";
		}

		setElec(elecNm);
		setElecApprYn(info.ELEC_APPR_YN);



		let question = info.QUESTION;
		if(question != null){
			let list = question.split('^||^');
			let qJson = {...qList};
			for(let i = 0; i < list.length; i++){
				qJson['q'+(i+1)] = list[i];
			}
			setQList(qJson);
		}


		setSuppCont(info.SUPP_CONT);
		setExeEffDesc(info.EXE_EFF_DESC);

		setTotalAmt(Number(info.TOT_AMT));
		setAddTotalAmt(Number(info.ADD_TOT_AMT));

		setCorpNm(result.CORP_NM);
		setBizNo(result.BIZ_NO);
		setCorpRegNo(result.CORP_REG_NO);
		
		let foreTskYn = info.FORE_TSK_YN ? info.FORE_TSK_YN : '';
		setForeTskYn(foreTskYn);
		
		if(info.TSK_PIC_PERSON_NM != null && info.TSK_PIC_PERSON_NM != ''){
			setPersonNm(info.TSK_PIC_PERSON_NM);
	  		setDeptNm(info.TSK_PIC_DEPT_NM); 
	  		setPosiNm(info.TSK_PIC_POSI_NM); 
			setEmailAdres(info.TSK_PIC_EMAIL_ADRES); 
	 		setOfcTelNo(info.TSK_PIC_OFC_TEL_NO); 
		}else{
			setPersonNm(result.PERSON_NM);
			setPosiNm(result.POSI_NM);
			setDeptNm(result.DEPT_NM);
			setEmailAdres(result.EMAIL_ADRES);
			setOfcTelNo(result.OFC_TEL_NO);
		}
		
		setAmtList(result.REC3);
		setAddAmtList(result.REC4);
		setCorpList(result.REC2);

		if(result.REC2.length != 0){
			setSelectCorpList(
				result.REC2.map(function(value){
					return value.CORP_NM
				}).join(',')
			)
		}

		otherFiles.setTbComFileMapngDetailList([]);
		reqFileValue.setTbComFileMapngDetailList([]);
		planFileValue.setTbComFileMapngDetailList([]);
		bizFileValue.setTbComFileMapngDetailList([]);

		let fileList = result.FILE_INFO;
		for(let i = 0; i < fileList.length; i++){
			if(fileList[i].FILE_GB == 'REQ'){
				let reqFileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(reqFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(reqFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(reqFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(reqFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(reqFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(reqFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(reqFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(reqFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(reqFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(reqFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(reqFileInfo.REGIST_DT);
				reqFileValue.putTbComFileMapngDetailList(fileDetail);
				setReqFileNm(reqFileInfo.ORGINL_FILE_NM);

			}else if(fileList[i].FILE_GB == 'PLAN'){
				let planFileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(planFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(planFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(planFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(planFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(planFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(planFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(planFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(planFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(planFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(planFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(planFileInfo.REGIST_DT);
				planFileValue.putTbComFileMapngDetailList(fileDetail);

				setPlanFileNm(planFileInfo.ORGINL_FILE_NM);

			}else if(fileList[i].FILE_GB == 'BIZ'){
				let bizFileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(bizFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(bizFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(bizFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(bizFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(bizFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(bizFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(bizFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(bizFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(bizFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(bizFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(bizFileInfo.REGIST_DT);
				bizFileValue.putTbComFileMapngDetailList(fileDetail);

				setBizFileNm(bizFileInfo.ORGINL_FILE_NM);

			}else{
				let otherFileInfo = fileList[i];

				//파일등록 정보
				const fileDetail = new TbComFileMapngDetail();
				fileDetail.setDwldId(otherFileInfo.DWLD_ID);
				fileDetail.setFileDetailId(otherFileInfo.FILE_DETAIL_ID);
				fileDetail.setFilePolicy(otherFileInfo.FILE_POLICY);
				fileDetail.setFileRpstr(otherFileInfo.FILE_RPSTR);
				fileDetail.setStrePath(otherFileInfo.STRE_PATH);
				fileDetail.setStreFileNm(otherFileInfo.STRE_FILE_NM);
				fileDetail.setOrginlFileNm(otherFileInfo.ORGINL_FILE_NM);
				fileDetail.setFileExtsn(otherFileInfo.FILE_EXTSN);
				fileDetail.setFileSize(otherFileInfo.FILE_SIZE);
				fileDetail.setRegistPsnNm(otherFileInfo.REGIST_PSN_NM);
				fileDetail.setRegistDt(otherFileInfo.REGIST_DT);
				otherFiles.putTbComFileMapngDetailList(fileDetail);
			}
		}

		setLoadFinish(true);


		// @ts-ignore
		if(typeof result == 'undefined'){
			//alert('data is not loaded!!!')
			return;
		}
	};


	//기부금 사용용도에 따른 과제 대분류 가져오기
	async function changeFunPurUseNo(code:string){
		let value = CommonUtil.suppSizeMappingVal(code);
		if(StringUtil.isEmpty(value))
			return [];

		let suppSizeA = codeDataStore.get("common.suppSizeA," + value);
		if(suppSizeA == null || suppSizeA.length === 0) {
			await codeDataStore.read("common.suppSizeA," + value)
			suppSizeA = codeDataStore.get("common.suppSizeA," + value);
		}
		console.log('funPurUseNo : ' + value)
		return suppSizeA;
	}

	//과제 대분류로 과제 소분류 가지고 오기 //처음 세팅용도
	async function changeSuppSizeA(funPurUseNo: string, code: string){
		if(StringUtil.isEmpty(code))
			return [];

		let suppSizeB = codeDataStore.get("common.suppSizeB," + funPurUseNo + "," + code);
		if(suppSizeB == null || suppSizeB.length === 0) {
			await codeDataStore.read("common.suppSizeB," + funPurUseNo + "," + code);
			suppSizeB = codeDataStore.get("common.suppSizeB," + funPurUseNo + "," + code);
			console.log('after / funPurUseNo : ' + funPurUseNo + ' / code : ' + code + ' / ' + JSON.stringify(suppSizeB))
		}
		return suppSizeB;
	}



	// init
	React.useEffect( () => {
		initCall();

		return () => {
		}
	},[])


	// init
	React.useEffect( () => {
		console.log("state", state);
	},[state])



	// init
	React.useEffect(() => {

		//필요한 공통코드 로딩.
		codeDataStore.read("[SCS]", "[FPUC]", "cfms.portalBizCdList", "[INC]", "[EFC]").then(() => {
			console.log("[INC]", codeDataStore.get("[INC]"))
			console.log("[EFC]", codeDataStore.get("[EFC]"))
			console.log("ccfms.portalBizCdList", codeDataStore.get("cfms.portalBizCdList"))
		});

		codeDataStore.read("common.suppSizeA," + funPurUseNo, "common.suppSizeB," + funPurUseNo + "," + bizKindCd1);
		initCall();

		return () => {

		}


	},[])

	function moveBack(){
		let vTSK_REQ_NO = TSK_REQ_NO.replaceAll('-', '');
		let vTSK_REQ_MODI_SEQ = TSK_REQ_MODI_SEQ

		let dataToSend = {vTSK_REQ_NO,vTSK_REQ_MODI_SEQ,vAll_PARAM:receivedData.vAll_PARAM};
		paramStore.setParam("adm1306", dataToSend);
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './adm1306',
			state: { data: dataToSend }
		});
	}

	if(!loadFinish)
		return (
			<PageLoading/>
		);
	else
	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={0} lnbD1Idx={2}  lnbD2Idx={2}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">과제 신청 내용 수정</h1>
					<h3 className="section-title mb15">과제 신청 정보</h3>
					<form className="fo fo-col2 mb30" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">과제명</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={tskNm} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">과제신청번호</p>
								<div className="fo-value">
								<UIInput className={'tf tf-md w100p'} value={TSK_REQ_NO} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">진행상태</p>
								<div className="fo-value">
									{tskReqStsNm == '신청' ? (<label className="badge badge-22 blue">신청</label>) : ''}
									{tskReqStsNm == '접수완료' ? ( <label className="badge badge-22 green">접수완료</label>) : ''}
									{tskReqStsNm == '수정요청' ? ( <label className="badge badge-22 yellow">수정요청</label>) : ''}
									{tskReqStsNm == '반려' ? (<label className="badge badge-22 red">반려</label>) : ''}
									{tskReqStsNm == '변경심사' ? ( <label className="badge badge-22 purple">변경심사</label>) : ''}
									{tskReqStsNm == '심사완료' ? ( <label className="badge badge-22 gray">심사완료</label>) : ''}
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">과제신청일</p>
								<div className="fo-value">
									{tskReqDate}
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">과제기간</p>
								<div className="fo-value">
									{dateToStr(tskStDate)}
									<span className="hz-item">~</span>
									{dateToStr(tskEnDate)}
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">제출여부</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={subYn} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">전자인증 여부</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={elec} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">과제종료여부</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={cloYn} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">과제종료일</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={tskCloDate} placeholder={''} readOnly={true} />
								</div>
							</div>

							<div className="fo-rs-tit row6">유형</div>

							<div className="fo-item fo-item-rs">
								<p className="fo-key">출연사업</p>
								<div className="fo-value">
									<div className="sl sl-md w100p">
										<div className="fo-value"><UIInput className={'tf tf-md w100p'} value={bizNm} placeholder={''} readOnly={true} /></div>
									</div>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">기금사용용도</p>
								<div className="fo-value">
									<div className="sl sl-md w100p">
										<UISelect
											codeData={codeDataStore.get("[FPUC]")}
											value={state.funPurUseCd}
											valueChanged={(value) => {
												const code = String(value);
												(async () => {
													const bizKindCd1List = await changeFunPurUseNo(code);
													let codeValue = CommonUtil.suppSizeMappingVal(code);
													setState({
														...state,
														funPurUseNo:codeValue,
														funPurUseCd: code,
														bizKindCd1List: bizKindCd1List
													});
												})();
											}}
											firstName={"sel"}
										/>
									</div>
								</div>
							</div>
							<div className="fo-item fo-item-rs">
								<p className="fo-key">과제분류(대분류)</p>
								<div className="fo-value">
									<div className="sl sl-md w100p">
										<UISelect
											codeData={state.bizKindCd1List}
											value={state.bizKindCd1}
											valueChanged={
												(value) => {
													if(loadFinish) {
														const code = String(value);
														(async () => {
															const bizKindCd2List = await changeSuppSizeA(state.funPurUseNo, code);
															// const bizKindCd2List = codeDataStore.get("common.suppSizeB," + state.funPurUseNo + "," + code);
															setState({
																...state,
																bizKindCd1: code,
																bizKindCd2List: bizKindCd2List
															});
														})();
													}
													// codeDataStore.read("common.suppSizeB," + funPurUseNo + "," + value).then(() => {
													// 	console.log("common.suppSizeB", codeDataStore.get("common.suppSizeB," + funPurUseNo + "," + value))
													// });
												}
											}
											firstName={"sel"}
										/>
									</div>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">과제분류(소분류)</p>
								<div className="fo-value">
									<div className="sl sl-md w100p">
										<UISelect
											codeData={state.bizKindCd2List}
											/*codeData={codeDataStore.get("common.suppSizeB," + funPurUseNo + "," + bizKindCd1)}*/
											value={state.bizKindCd2}
											valueChanged={(value) => setState({...state, bizKindCd2:String(value)})}
											firstName={"sel"}
										/>
									</div>
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">기금정산방식</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={foreTskYn === 'Y' ? "선지급" : "사후정산"} placeholder={''} readOnly={true} />
								</div>
							</div>
						</div>
					</form>

					<section className="fund-section">
						<div className="hz-root hz-gap5 mb15">
							<h3 className="section-title">지원내용 및 기대효과</h3>
						</div>
						<form name="" action="" method="" className=" mb30">
							<div className="tb tb-narrow mb15">
								<table>
									<caption></caption>
									<colgroup>
										<col width="200px" />
										<col />
									</colgroup>
									<tbody>
									<tr>
										<th scope="row"><span className="th-req">과제개요</span></th>
										<td>
											<div className="ta-group w100p">
												{suppCont}
											</div>
										</td>
									</tr>
									<tr>
										<th scope="row" ><span className="th">정성효과</span></th>
										<td>
											<div className="ta-group w100p">
												{exeEffDesc}
											</div>
										</td>
									</tr>

									<tr>
										<th scope="row">기대효과</th>
										<td>
											<div className="fo fo-col2">
												<div className="inner">
													{ queList.length != 0 && queList.map((que, idx) => (
														<div className="fo-item" key={que.QUA_ID}>
															<p className="fo-key">{ que.QUA_TEXT }</p>
															<div className="fo-value">
																<UIInput className={'tf tf-md  w100p'} value={que.VALUE} readOnly={true}/>
															</div>
														</div>
													))}

												</div>
											</div>
										</td>
									</tr>
									</tbody>
								</table>
							</div>
						</form>
					</section>
					<h3 className="section-title mb15">지원 대상</h3>

					<form className="fo fo-col3 mb30" name="" action="" method="">
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">중소기업 지원 수</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={suppCorpCnt + ' 개사'} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">

									<span>중소기업 외 지원 수</span>&nbsp;
									<button type="button" className="button-tooltip" data-tooltip-id="tooltip">툴팁</button>
									<Tooltip
										id="tooltip"
										disableStyleInjection={true}
										place={"bottom-start"}
										className="tooltip-conts"
										//openOnClick
									>
										<div className="msg">
											{/* <h6 className="tooltip-title">상생협력기금은 중소기업에게만 지원 가능합니다.</h6> */}
											<p className="tx tx-cp1">상생협력기금은 중소기업에게만 지원 가능합니다.</p>
										</div>
									</Tooltip>
								</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={otherSuppCorpCnt + ' 개사'} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">합계</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={(Number(suppCorpCnt) + Number(otherSuppCorpCnt))+' 개사'} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item fo-m-1-4">
								<p className="fo-key">수행기관</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={selectCorpList} placeholder={''} readOnly={true} />
								</div>
							</div>
						</div>
					</form>

					<h3 className="section-title mb15">지원 항목 별 지원금</h3>
					<form className="fo fo-col4 mb0" name="" action="" method="">
					{amtList.map((amt, idx) => (
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">지원항목</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={amt.SUPP_ITEM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">산출근거</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={amt.CALC_BASIS} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">증빙방법</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={amt.PROF_MATH} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">금액(원)</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md ta-right w100p'} value={StringUtil.formatNumber(Number(amt.SUPP_AMT)) || ""} placeholder={''} readOnly={true} />
								</div>
							</div>
						</div>
					))}
					</form>
					<div className="tb-total mb30">
						<div className="tb-total-items">
							지원 항목별 합계금액 (원)
						</div>
						<div className="tb-total-items">
							<div className="fund-form-items tf-unit">
								<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(totalAmt)) || "0"} placeholder={''}  readOnly={true}/>
								<span className="u">원</span>
							</div>
							<p className="tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(totalAmt + "") ?
									StringUtil.numKorPattern(totalAmt) + " 원" : "원"})</span></p>
						</div>
					</div>

					{addAmtList.length > 0 &&
					<section className="">
					<h3 className="section-title mb15">출연잔액 외 추가과제승인 신청금액</h3>
					<form className="fo fo-col4 mb0" name="" action="" method="">
					{addAmtList.map((amt, idx) => (
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">지원항목</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={amt.ADD_SUPP_ITEM} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">산출근거</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={amt.ADD_CALC_BASIS} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">증빙방법</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={amt.ADD_PROF_MATH} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">금액(원)</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md ta-right w100p'} value={StringUtil.formatNumber(Number(amt.ADD_SUPP_AMT)) || ""} placeholder={''} readOnly={true} />
								</div>
							</div>
						</div>
					))}
					</form>
					<div className="tb-total mb30">
						<div className="tb-total-items">
							지원 항목별 합계금액 (원)
						</div>
						<div className="tb-total-items">
							<div className="fund-form-items tf-unit">
								<UIInput className={'tf tf-md ta-right'} value={StringUtil.formatNumber(Number(addTotalAmt)) || "0"} placeholder={''}  readOnly={true}/>
								<span className="u">원</span>
							</div>
							<p className="tx-msg"><span className="fc-pri">({StringUtil.isNotEmpty(addTotalAmt + "") ?
									StringUtil.numKorPattern(addTotalAmt) + " 원" : "원"})</span></p>
						</div>
					</div>
					</section>
					}
					
					<h3 className="section-title mb15">첨부파일</h3>
					<form className="fo fo-col2 mb30" name="" action="" method="">
						<div className="inner">
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">과제 신청서(필수)</p>
								<div className="fo-value">
									<div className="hz-root hz-sb w100p">
										{ elecApprYn == 'N' && reqFileValue.tbComFileMapngDetailList.length != 0 &&
											<UI.FileDownloadSimpleMode value={reqFileValue} viewMode={"simple2"}/>
										}
										{ elecApprYn == 'Y' &&
											<div>전자인증이 완료되었습니다.</div>
										}

										{ elecApprYn == 'N' && reqFileValue.tbComFileMapngDetailList.length == 0 &&
											<div>제출이 완료되지 않았습니다.</div>
										}

									</div>
								</div>
							</div>
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">과제계획서(필수)</p>
								<div className="fo-value">
									<div className="hz-root hz-sb w100p">
										{ planFileValue.tbComFileMapngDetailList.length != 0 &&
											<UI.FileDownloadSimpleMode value={planFileValue} viewMode={"simple2"}/>
										}

										{ planFileValue.tbComFileMapngDetailList.length == 0 &&
											<div>제출이 완료되지 않았습니다.</div>
										}
									</div>
								</div>
							</div>
							{ corpListText != '' &&
								<div className="fo-item fo-m-1-3 req">
									<p className="fo-key">수행기관 사업자 등록증 (수행기관 해당시만)</p>
									<div className="fo-value">
										<div className="hz-root hz-sb w100p">
											{ bizFileValue.tbComFileMapngDetailList.length != 0 &&
												<UI.FileDownloadSimpleMode value={bizFileValue} viewMode={"simple2"}/>
											}

											{ bizFileValue.tbComFileMapngDetailList.length == 0 &&
												<div>제출이 완료되지 않았습니다.</div>
											}
										</div>
									</div>
								</div>
							}
							<div className="fo-item fo-m-1-3">
								<p className="fo-key">첨부파일</p>
								<div className="fo-value">
									<UI.FileDownloadSimpleMode value={otherFiles} viewMode={"simple2"}/>
								</div>
							</div>
						</div>
					</form>

					<h3 className="section-title mb15">출연 기업정보</h3>
					<form className="fo fo-col2" name="" action="" method="">
						<div className="inner">
							<div className="fo-item">
								<p className="fo-key">기업명</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={corpNm} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">법인사업자번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={corpRegNo} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">사업자번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={bizNo} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item req">
								<p className="fo-key">담당자</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={personNm} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">직급</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={posiNm} placeholder={''} readOnly={true}  />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">부서</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={deptNm} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">이메일</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={emailAdres} placeholder={''} readOnly={true} />
								</div>
							</div>
							<div className="fo-item">
								<p className="fo-key">전화번호</p>
								<div className="fo-value">
									<UIInput className={'tf tf-md w100p'} value={StringUtil.telephoneFormat(ofcTelNo)} placeholder={''} readOnly={true}  />
								</div>
							</div>
						</div>
					</form>
					<div className="hz-root hz-right hz-gap5">
						<Button color="gray-o" size="sm" onClick={() => moveBack()}>취소</Button>
						<Button color="pri-o" size="sm" onClick={() => saveTsk()}>저장</Button>
					</div>
				</main>
			</div>

		</PageContainer>
	);
}
export default ContentsContainer;